import React from 'react';
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import ListItemIcon from "@mui/material/ListItemIcon";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BusinessIcon from '@mui/icons-material/Business';
import {routeConfigs} from "../../navigation/routeConfig";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import SellIcon from "@mui/icons-material/Sell";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

export const Dashboard:React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 4, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h1" variant="h5" sx={{mb: 2}}>
        Dashboard
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate(routeConfigs.pharmacyProfile.path)}>
            <ListItemIcon>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary="Pharmacy Profile" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate(routeConfigs.users.path)}>
            <ListItemIcon>
              <GroupAddIcon />
            </ListItemIcon>
            <ListItemText primary="Manage users" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate(routeConfigs.bankAccount.path)}>
            <ListItemIcon>
              <AccountBalanceIcon  />
            </ListItemIcon>
            <ListItemText primary="Bank info" />
          </ListItemButton>
        </Grid>


        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate('/')}>
            <ListItemIcon>
              <StorefrontRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Buy" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate('/sell')}>
            <ListItemIcon>
              <SellIcon />
            </ListItemIcon>
            <ListItemText primary="Sell" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate('/buy-history')}>
            <ListItemIcon>
              <FactCheckIcon />
            </ListItemIcon>
            <ListItemText primary="Buy History" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate('/open-orders')}>
            <ListItemIcon>
              <ShoppingCartIcon />
            </ListItemIcon>
            <ListItemText primary="Open Orders" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate('/sell-history')}>
            <ListItemIcon>
              <MonetizationOnIcon />
            </ListItemIcon>
            <ListItemText primary="Sell History" />
          </ListItemButton>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={4}>
          <ListItemButton onClick={() => navigate(routeConfigs.vacationMode.path)}>
            <ListItemIcon>
              <BeachAccessIcon />
            </ListItemIcon>
            <ListItemText primary="Vacation Mode" />
          </ListItemButton>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Dashboard;